"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatFunctions_1 = require("./formatFunctions");
var TimeSpan_1 = require("./TimeSpan");
var precisions = [1, 10, 1e2, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8];
exports.monthNames = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'];
exports.monthShort = ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];
exports.dayNames = ['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela'];
var dayNames2 = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
exports.dayShort = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
var dayShort2 = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
exports.formatDateFunction = {
    'dd.MM.yyyy': function (dt) { return padNumber(dt.getDate()) + '.' + padNumber(dt.getMonth() + 1) + '.' + dt.getFullYear(); },
    'yyyy-MM-dd': function (dt) { return dt.getFullYear() + '-' + padNumber(dt.getMonth() + 1) + '-' + padNumber(dt.getDate()); },
    'MMMM yyyy': function (dt) { return exports.monthNames[dt.getMonth()] + " " + dt.getFullYear(); },
    'MMM yyyy': function (dt) { return exports.monthShort[dt.getMonth()] + " " + dt.getFullYear(); },
    'dddd': function (dt) { return dayNames2[dt.getDay()]; },
    'ddd': function (dt) { return dayShort2[dt.getDay()]; },
    'dd': function (dt) { return padNumber(dt.getDate()); },
    'd': function (dt) { return dt.getDate().toString(); },
    'MMMM': function (dt) { return exports.monthNames[dt.getMonth()]; },
    'MMM': function (dt) { return exports.monthShort[dt.getMonth()]; },
    'MM': function (dt) { return padNumber(dt.getMonth() + 1); },
    'M': function (dt) { return (dt.getMonth() + 1).toString(); },
    'HH': function (dt) { return padNumber(dt.getHours()); },
    'H': function (dt) { return dt.getHours().toString(); },
    'mm': function (dt) { return padNumber(dt.getMinutes()); },
    'm': function (dt) { return dt.getMinutes().toString(); },
    'ss': function (dt) { return padNumber(dt.getSeconds()); },
    's': function (dt) { return dt.getSeconds().toString(); },
    'HH:mm:ss': function (dt) { return padNumber(dt.getHours()) + ":" + padNumber(dt.getMinutes()) + ":" + padNumber(dt.getSeconds()); },
    'dd.MM.yyyy HH:mm:ss': function (dt) { return exports.formatDateFunction['dd.MM.yyyy'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt); },
    'yyyy-MM-dd HH:mm:ss': function (dt) { return exports.formatDateFunction['yyyy-MM-dd'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt); }
};
/**
 * zaokrągla liczbę zmiennoprzecinkową uwzględniając przekłamania JS
 * @param value liczba
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function mround(value, precision) {
    if (precision === void 0) { precision = 2; }
    if (value === undefined) {
        return value;
    }
    // return Number(Math.round(+(`${value}e${precision}`)) + `e-${precision}`);
    var nnumber = value * precisions[precision];
    if (nnumber % 1 === 0) {
        return value;
    }
    else {
        return Math.round(nnumber + 0.0000000000001) / precisions[precision];
    }
}
exports.mround = mround;
/**
 * dodaje widoące zera do liczby
 * @param value liczba
 * @param minLength minimalna, wynikowa długośc tekstu
 */
function padNumber(value, minLength) {
    if (minLength === void 0) { minLength = 2; }
    var result = '' + value;
    while (result.length < minLength) {
        result = '0' + result;
    }
    return result;
}
exports.padNumber = padNumber;
/**
 * zwraca maksymalną wartość
 * @param values tablica wartości
 */
function max(values) {
    var result = values[0];
    var i = values.length;
    while (--i > 0) {
        if (values[i] > result) {
            result = values[i];
        }
    }
    return result;
}
exports.max = max;
/**
 * zwraca minimalną wartość
 * @param values tablica wartości
 */
function min(values) {
    var result = values[0];
    var i = values.length;
    while (--i > 0) {
        if (values[i] < result) {
            result = values[i];
        }
    }
    return result;
}
exports.min = min;
function nullDefault(value, valueIfNull) {
    return value === null ? valueIfNull : value;
}
exports.nullDefault = nullDefault;
var precisionsz = ['', '.0', '.00', '.000', '.0000', '.00000', '.000000', '.0000000', '.00000000'];
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function fmoney(value, forcezeros, precision) {
    if (precision === void 0) { precision = 2; }
    if (value === null) {
        return '';
    }
    // const s = value.toFixed(2);
    // let s = mround(value, precision).toFixed(precision);
    if (value % 1 === 0) {
        if (forcezeros) {
            return value.toString() + precisionsz[precision];
        }
        else {
            return value.toString();
        }
    }
    var s = mround(value, precision).toFixed(precision);
    if (forcezeros) {
        return s.replace('.', ',');
    }
    else {
        return s.replace(precisionsz[precision], '').replace('.', ',');
    }
}
exports.fmoney = fmoney;
/**
 * formatuje datę do formatu yyyy-MM-dd
 * @param dt data typu Date
 */
function fdate(dt) {
    return exports.formatDateFunction['yyyy-MM-dd'](dt);
    // return dt.getFullYear() + '-' + padNumber(dt.getMonth() + 1) + '-' + padNumber(dt.getDate());
}
exports.fdate = fdate;
/**
 * formatuje czas do formatu HH:mm:ss
 * @param dt data typu Date
 */
function ftime(dt) {
    return exports.formatDateFunction['HH:mm:ss'](dt);
    // return padNumber(dt.getHours()) + ':' + padNumber(dt.getMinutes()) + ':' + padNumber(dt.getSeconds());
}
exports.ftime = ftime;
/**
 * formatuje datę i czas do formatu yyyy-MM-dd HH:mm:ss
 * @param dt data typu Date
 */
function fdatetime(dt, format) {
    return exports.formatDateFunction[format || 'yyyy-MM-dd HH:mm:ss'](dt);
    // return fdate(dt) + ' ' + ftime(dt);
}
exports.fdatetime = fdatetime;
/**
 * generuje guid w formacie xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
function generateGuid() {
    var g = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return g.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
    // return g;
}
exports.generateGuid = generateGuid;
function _getInt(s, start, length) {
    if (start < s.length) {
        return +s.substr(start, length);
        var res = +s.substr(start, length);
        if (!isNaN(res)) {
            return res;
        }
    }
    return 0;
}
/**
 * zwraca liczbę reprezetującą częśc daty
 * @param date data w formacie yyyy-MM-dd HH:mm:ss
 * @param part rok:y,yy,yyy,year;
 * miesiąc:M,MM,month;
 * dzien:d,dd,day;
 * godzina:h,hh,hour;
 * minuta:m,mm,minute;
 * sekunda:s,ss,second;
 */
function datePart(date, part) {
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            return _getInt(date, 0, 4);
        case 'M':
        case 'MM':
        case 'month':
            return _getInt(date, 5, 2);
        case 'd':
        case 'dd':
        case 'day':
            return _getInt(date, 8, 2);
        case 'h':
        case 'hh':
        case 'hour':
            return _getInt(date, 11, 2);
        case 'm':
        case 'mm':
        case 'minute':
            return _getInt(date, 14, 2);
        case 's':
        case 'ss':
        case 'second':
            return _getInt(date, 17, 2);
        default:
            return 0;
    }
}
exports.datePart = datePart;
function dateDiff(lateDate, earlyDate) {
    return TimeSpan_1.default.diff(lateDate, earlyDate);
}
exports.dateDiff = dateDiff;
function dateParse(date) {
    if (date.length === 10) {
        return new Date(date + ' 00:00:00');
    }
    else {
        return new Date(date);
    }
}
exports.dateParse = dateParse;
/**
 * dodaje określoną liczbę jednostek do daty
 * @param date data wejściowa
 * @param part częśc daty do zmiany
 * @param value o lie zwiększyć
 */
function dateAdd(date, part, value) {
    var inputDate = dateParse(date);
    var result = new Date(inputDate);
    switch (part) {
        case 'y':
        case 'yy':
        case 'yyyy':
        case 'year':
            result.setFullYear(inputDate.getFullYear() + value);
            break;
        // return padNumber(datePart('y', date) + value, 4) + date.substr(4);
        case 'M':
        case 'MM':
        case 'month':
            result.setMonth(inputDate.getMonth() + value);
            break;
        case 'd':
        case 'dd':
        case 'day':
            result.setDate(inputDate.getDate() + value);
            break;
        case 'h':
        case 'hh':
        case 'hour':
            result.setHours(inputDate.getHours() + value);
            break;
        case 'm':
        case 'mm':
        case 'minute':
            result.setMinutes(inputDate.getMinutes() + value);
            break;
        case 's':
        case 'ss':
        case 'second':
            result.setSeconds(inputDate.getSeconds() + value);
            break;
    }
    if (date.length === 10) {
        return fdatetime(result).replace(' 00:00:00', '');
    }
    else {
        return fdatetime(result);
    }
}
exports.dateAdd = dateAdd;
/**
 * Zwraca tablicę zawierającą listę miesięcy pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 * @param format format, domyślnie MMMM yyyy, czyli "styczeń 2019"
 */
function listMonths(startDate, endDate, format /* = 'MMMM yyyy'*/) {
    /*
    const dt1 = dateParse(startDate);
    const dt2 = dateParse(endDate);

    let m1 = dt1.getMonth();
    let y1 = dt1.getFullYear();
    const m2 = dt2.getMonth();
    const y2 = dt2.getFullYear();
    */
    var m1 = datePart(startDate, 'M') - 1;
    var y1 = datePart(startDate, 'y');
    var m2 = datePart(endDate, 'M') - 1;
    var y2 = datePart(endDate, 'y');
    var result = [];
    var func;
    switch (format) {
        case 'MMMM yyyy':
            func = function (m, y) { return exports.monthNames[m] + ' ' + y; };
            break;
        case 'MMM yyyy':
            func = function (m, y) { return exports.monthShort[m] + ' ' + y; };
            break;
        case 'MM yyyy':
            func = function (m, y) { return padNumber(m + 1) + ' ' + y; };
            break;
        case 'M yyyy':
            func = function (m, y) { return (m + 1) + ' ' + y; };
            break;
        case 'MMMM':
            func = function (m, y) { return exports.monthNames[m]; };
            break;
        case 'MMM':
            func = function (m, y) { return exports.monthShort[m]; };
            break;
        case 'MM':
            func = function (m, y) { return padNumber(m + 1); };
            break;
        case 'M':
            func = function (m, y) { return (m + 1).toString(); };
            break;
        default:
            func = function (m, y) { return exports.monthNames[m] + ' ' + y; };
            break;
    }
    while ((m1 <= m2 && y1 === y2) || (y1 < y2)) {
        result.push(func(m1, y1));
        m1++;
        if (m1 > 11) {
            m1 = 0;
            y1++;
        }
    }
    return result;
}
exports.listMonths = listMonths;
/**
 * Zwraca tablicę zawierającą listę lat pomiędzy datami
 * @param startDate data początkowa
 * @param endDate data końcowa
 */
function listYears(startDate, endDate) {
    var y1 = datePart(startDate, 'y');
    var y2 = datePart(endDate, 'y');
    var result = [];
    while (y1 <= y2) {
        result.push(y1);
        y1++;
    }
    return result;
}
exports.listYears = listYears;
/**
 * dzisiejsza data w dormacie yyyy-MM-dd
 */
function today() {
    return fdate(new Date());
}
exports.today = today;
/**
 * aktualna data i czas w formacie yyyy-MM-dd HH:mm:ss
 */
function now() {
    return fdatetime(new Date());
}
exports.now = now;
/**
 * Sprawdza czy tekst jest podanego formatu
 * @param format format tekstu
 * @param value wartośc do weryfikacji
 */
function check(format, value) {
    return formatFunctions_1.checkFormat(format, value);
}
exports.check = check;
/*
export default {
    mround,
    min,
    max,
    nullDefault,
    fmoney,
    fdate,
    ftime,
    fdatetime,
    padNumber,
    datePart,

    dateAdd,
    dateDiff: TimeSpan.diff,
    today: () => fdate(new Date()),
    now: () => fdatetime(new Date()),
    guid: generateGuid,
    check: (format: string, value: string): boolean => checkFormat(format, value),
    checkFormat,
};
*/
//# sourceMappingURL=schemaMethods.js.map